export default __webpack_public_path__ + "img/shop.3a161bb0.svg";